<script setup lang="ts">
import { getDomain } from '@sembo-private/utils';
import { onMounted } from 'vue';

import { importCSSFromUrl } from '@apps/main/modules/helpers/importCssFromUrl';

import { performanceMark } from '@libs/utils';

import { usePreviouslyUserSessionStore } from './new-desktop/core/stores/previouslyUserSession/previouslyUserSessionStore';

const previouslyUserSessionStore = usePreviouslyUserSessionStore();
document.title = `${getDomain.getCurrentDomainSpec().Title}`;
importCSSFromUrl();

onMounted(() => {
  performanceMark('AppInitiated');
  previouslyUserSessionStore.loadPreviouslySeenHotels();
  previouslyUserSessionStore.cleanOldHotels();
});
</script>

<template>
  <router-view />
</template>
